import { Paper, SxProps, Theme } from "@mui/material";
import { PropsWithChildren } from 'react';

export type StepMenuLandingContainerProps = {
    sx?: SxProps<Theme>    
};

export default function StepMenuLandingContainer({
    sx,
    children
}: PropsWithChildren<StepMenuLandingContainerProps>) {
    return (
        <Paper sx={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflow: "hidden",
            backgroundColor: "custom.background.cardContainer",
            ...sx
        }}
            elevation={0}
        >
            {children}
        </Paper>
    );
}